import { render, staticRenderFns } from "./SetUsername.vue?vue&type=template&id=27c96191&scoped=true"
import script from "./SetUsername.vue?vue&type=script&lang=js"
export * from "./SetUsername.vue?vue&type=script&lang=js"
import style0 from "./SetUsername.vue?vue&type=style&index=0&id=27c96191&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c96191",
  null
  
)

export default component.exports